<template>
    <div class="courseDescription flex-align-center">
        <div class="courseDescription_box">
            <div class="course-info flex-layout">
                <!-- downloadURL + courseInfo.cover + '&width=450' -->
                <img class="cover" :src="downloadURL + courseInfo.cover + '&width=450'"
                    :onerror="$store.state.course.defaultCourseCover[$route.query.index % 6]" />
                <div class="base-info-right">
                    <div class="info-part flex-between">
                        <div>
                            <p class="title">{{ courseInfo.name || '' }}</p>
                            <p class="project-name">{{ courseInfo.project.name || '' }}项目</p>
                            <p class="teacher">授课老师：{{ courseInfo.teacherInfo.name || '' }}</p>
                            <p class="time">课程时间：{{ courseInfo.timeScope || '' }}</p>
                        </div>
                    </div>
                    <div class="count-data flex-align-around">
                        <div class="flex-column-center" v-for="(item, index) in countDatas" :key="index">
                            <span v-if="item.title != 'playbackTime' && item.title != 'liveTime'" class="count">{{
                                item.value }}<i>{{ item.unit }}</i></span>
                            <span v-else class="count">
                                {{ item.value | MinFormat('min') }}<i>{{ item.unit }}</i>
                                {{ item.value | MinFormat('second') }}<i>秒</i>
                            </span>
                            <br />{{ item.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="detail-info">
                <div class="catalog">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="课程目录" name="first">
                            <div class="courseListbox">
                                <div class="courseli" v-for="(item, index) in LessonNewList" :key="index">
                                    <div class="courseli_box flex-align-between"
                                        :class="!item.lessonFiles && 'courseli_box_r'">
                                        <div class="courseType flex-column">
                                            <div class="courseType_T">
                                                <div class="courseTitle wes-2">{{ item.name }}</div>
                                                <div class="courseTime">
                                                    <span v-if="item.lessonsPattern !== 0">开放时间：</span>
                                                    <span>{{ dayjs(item.lessonsBeginTime * 1000).format('YYYY.MM.DD HH:mm')
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="courseType_B flex-align-between">
                                                <div class="courseType_B_left">
                                                    <!-- <span>直播学习时长: 0 分钟</span> -->
                                                    <span>观看时长: {{ parseInt(item.playbackTime / 60) || 0 }}分钟</span>
                                                </div>
                                                <!-- <div class="courseType_B_right">
                                                <span>回放完成时长:0分钟 0 秒</span>
                                                <span>进度：0%</span>
                                            </div> -->
                                            </div>
                                        </div>
                                        <div class="courseBtn flex-align-center">
                                            <!-- <el-button type="primary" class="into-course btn"
                                            :class="[markMap[11].class]">
                                            {{ markMap[11].text }}
                                        </el-button> -->
                                            <!-- <div class="into-course btn flex-align-center" @click="tovideo(item)"
                                            :class="[markMap[courseInfo.mark].class]">
                                            {{ markMap[courseInfo.mark].text }}
                                        </div> -->
                                            <div class="into-course btn flex-align-center" @click="tovideo(item)">
                                                查看
                                            </div>
                                        </div>
                                    </div>
                                    <div class="attachment_list" v-if="item.lessonFiles">
                                        <div class="attachment flex-align-between" v-for="(file, index) in item.lessonFiles"
                                            :key="index">
                                            <div class="attachmentName" @click="downloadFile(file)">
                                                <span>【资料】</span>
                                                {{ file.fileName }}
                                            </div>
                                            <div class="download-icon">
                                                <img src="../../assets/images/course/download.png" alt="" class="csp"
                                                    @click="downloadFile(file)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="简介" name="second">
                            <div class="courseListbox">
                                <p class="synopsis" v-if="courseInfo.courseExplain != ''">
                                    {{ courseInfo.courseExplain }}
                                </p>
                                <Empty :show="true" :text="'暂无评论'" v-else></Empty>
                            </div>
                        </el-tab-pane>

                    </el-tabs>
                </div>
                <div class="aside">
                    <div class="teacher-info">
                        <h4>授课老师</h4>
                        <div class="name-part">
                            <img :src="courseInfo.teacherInfo && downloadURL + courseInfo.teacherInfo.avatar" alt=""
                                :onerror="$store.state.user.defaultAvatar" class="avatar" />
                            <span class="name">{{ courseInfo.teacherInfo && courseInfo.teacherInfo.name }}</span>
                            <span class="title">{{ courseInfo.teacherInfo && courseInfo.teacherInfo.title }}</span>
                        </div>
                        <p class="discribe">
                            {{ courseInfo.teacherInfo && courseInfo.teacherInfo.introduce || '暂无简介' }}
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Empty from '../components/common/empty.vue'
export default {
    //import引入组件才能使用
    components: {
        Empty
    },
    props: {},
    data() {
        return {
            countDatas: [{
                name: '学习总时长',
                title: 'playbackTime',
                unit: '分钟',
                value: 0,
            }],
            activeName: 'first',
            courseInfo: {
                cover: '',
                name: '',
                courseExplain: '',
                project: {
                    name: '',
                },
                teacherInfo: {
                    name: '',
                    title: '',
                    introduce: '',
                    avatar: ''
                },
                timeScope: '',
                mark: ''
            },
            LessonNewList: [],
            markMap: this.$store.state.course.markMap,

        };
    },
    filters: {
        // 分钟转时分秒
        transformTimeFormat(value, type) {
            if (!value) return 0;

            if (type == 'hour' && value >= 3600) {
                return parseInt((value / 3600));
            }

            if (type == 'min' && value >= 3600) {
                return parseInt((value % 3600) / 60);
            }

            if (type == 'min' && value < 3600) {
                return parseInt(value / 60);
            }
            if (type == 'second') return parseInt(value % 60);
        },
        // 秒转分钟
        MinFormat(value, type) {
            if (!value) return 0;
            if (type == 'min') {
                return parseInt(value / 60);
            }
            if (type == 'second') return parseInt(value % 60);
        },
    },
    // 计算属性
    computed: {

    },
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        //课程详情
        async getparticulars() {
            let resData = await Api.Curriculum.findCourse(this.$route.query.id);
            this.courseInfo = resData.data;
            console.log('课程详情', resData);
            this.changeBreadName(resData.data.name)
        },
        //获取时间类型
        async getCourseStudyInfo() {
            let nameMap = {
                playbackTime: {
                    name: '学习总时长',
                    unit: '分钟',
                }
            };
            let data = {
                courseId: this.$route.query.id,
                platform: this.$route.query.videoType
            }
            let resData = await Api.Curriculum.getCourseStudyInfo2(data);
            if (!resData.data || JSON.stringify(resData.data) == '[]') return;
            this.countDatas = [];
            for (const key in nameMap) {
                let obj = {
                    title: key,
                    name: nameMap[key].name,
                    value: resData.data[key],
                    unit: nameMap[key].unit
                }
                this.countDatas.push(obj);
            }

        },
        //课程内容列表
        async getLessonNewList() {
            let resData = await Api.Curriculum.getLessonNewList(this.$route.query.id);
            this.LessonNewList = resData.data;
            console.log('resData', resData);
        },
        //时间处理
        MinFormat(value, type) {
            // console.log(value)
            if (!value) return 0;
            if (type == 'min') {
                return parseInt(value / 60);
            }
            if (type == 'second') return parseInt(value % 60);
        },
        handleClick() {

        },
        tovideo(item) {
            this.$router.push({
                path: `/home/curriculumPublic/video/${item.id}`,
                query: {
                    'id': item.id,
                    'videoType': this.$route.query.videoType,
                    'breadNumber': 4,
                }
            });
        },
        //下载附件
        downloadFile(file) {
            let address = file.url ? file.url : file.identifier ? file.identifier : file.fileIdentifier;
            let fileToken = sessionStorage.getItem('fileToken');
            window.open(`${VueInstance.downloadURL}${address}&token=${fileToken}&type=2`)
        },
        changeBreadName(name) {
            // console.log('跳转课程详情labelList', this.$store.state.basics.breadList);
            this.$store.commit('breadPageNameChange', name)
            // console.log('修改后课程详情labelList', this.$store.state.basics.breadList);

        }

    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        this.getparticulars();
        this.getCourseStudyInfo();
        this.getLessonNewList();

    },
    beforeCreate() { },//生命周期：创建之前
    beforeMount() { },//生命周期：挂载之前
    beforeUpdate() { },//生命周期：更新之前
    updated() { },//生命周期：更新之后
    beforeDestroy() { },//生命周期：销毁之前
    destroyed() { },//生命周期：销毁完成
    activated() { },//如果页面有keep-alive缓存功能，这个函数会触发执行
}
</script>
<style lang="less" scoped>
@import'./less/courseDescription.less';
</style>